<template>
  <div class="d-content">
    <dashboard-content-nav :nav="navItems" />
    <keep-alive>
      <component :is="currentComponent" :entity_index="entity_index"></component>
    </keep-alive>
  </div>
</template>
<script>
import dashboardContentNav from "@/components/dashboard/contentNav.vue";

//Pages
import reportsCentral from "./reportCentral.vue";
import myReports from "./myReports.vue";
import companyReports from "./companyReports.vue";
import reports from "./reports.vue";
import salaryReports from "./salaryreports/SalaryReports.vue"
import salaryRegister from "./salaryreports/SalaryRegister.vue";
import payrollReport from "./payrollReport.vue"


const mapNameToComponents = {
  "reportsDashboard": reports,
  "myReports": myReports,
  "companyReports": companyReports,
  "salaryReports": salaryReports,
  "salaryRegister": salaryRegister,
  "payrollReport": payrollReport,
  reportsCentral: reportsCentral,
  // reportsDashboard: reportsDashboard,
  "components": () => import('./reportcomponents.vue'),
  "employees": () => import('./selectedemployees.vue'),
  "custom": () => import('./customreports.vue'),
};



const getPathForStep = (entity_index,step_name, sub_step) => {
  if (sub_step) {
    return `/dashboard/${entity_index}/reports/${step_name}/${sub_step}`;
  } else {
    return `/dashboard/${entity_index}/reports/${step_name}`;
  }
};

const nav_items = (entity_index) => [
  {
    type: "navitem",
    label: "Reports",
    path: getPathForStep(entity_index, "reportsDashboard", "myReports"),
    icon: "icon-reports",
    children:[
      {
        },
    ]
  }
  // {
  //   type: "navitem",
  //   label: "Company Reports",
  //   path: getPathForStep(entity_index, "reportsDashboard", "companyReports"),
  //   icon: "icon-reports",
  //   children:[
  //     {
  //       },
  //   ]
  // }

];

export default {
  components: {
    dashboardContentNav
  },
  props: ["step_name", "sub_step", "sub_step_name","entity_index"],
  data() {
    return {
      navItems: []
    };
  },
  methods: {
    contentShow(event) {
      var sections = document.querySelectorAll(".d-payroll__accordBlock");
      for (let i = 0; i < sections.length; i++) {
        sections[i].classList.remove("active");
      }
      event.target.parentNode.classList.toggle("active");
    }
  },
  created() {
    this.navItems = nav_items(this.entity_index);
  },
  computed: {
    currentComponent: function() {
      if (this.sub_step_name) {
        return mapNameToComponents[this.sub_step_name];
      } else {
        return mapNameToComponents[this.sub_step];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section
</style>
